import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare const gtag: (...args: any[]) => void;

@Injectable({
    providedIn: 'root',
})
export class AnalyticsService {
    private fire(eventName: string, params?: Record<string, any>): void {
        if (!environment.production || typeof gtag === 'undefined') return;
        gtag('event', eventName, params);
    }

    signupComplete(method: 'email' | 'google'): void {
        this.fire('sign_up', { method });
    }

    postCreated(type: 'sale' | 'accommodation'): void {
        this.fire('post_created', { post_type: type });
    }

    chatStarted(context: 'sale' | 'accommodation' | 'profile'): void {
        this.fire('chat_started', { context });
    }

    /** `method`: the phone's share sheet, or the link copied where there isn't one. */
    saleShared(method: 'share_sheet' | 'copy_link'): void {
        this.fire('share', { content_type: 'sale', method });
    }

    saleMarkedSold(): void {
        this.fire('sale_marked_sold');
    }

    ppaReviewed(): void {
        this.fire('ppa_reviewed');
    }
}
